import React from 'react';

export default function OtpField(props) {
  const { name, formik, placeholder } = props;

  const handleChange = (event) => {
    formik.handleChange(event);

    const currentIndex = parseInt(name.slice(-1), 10);

    if (currentIndex < 4) {
      const nextInput = document.getElementsByName(`otp${currentIndex + 1}`)[0];
      if (nextInput) {
        nextInput.focus();
      }
    }
  };

  return (
    <>
      <input
        type="number"
        name={name}
        value={formik.values[name]}
        onChange={handleChange}
        className="py-4 px-3 bg-[#E4E6E3] w-14 h-15 rounded-full otp border-none placeholder:text-info focus:text-info focus:border-none outline-none focus:outline-none focus:ring-0 font-imprima text-center"
        placeholder={placeholder}
        min={0}
        max={9}
        required
      />
    </>
  );
}
